import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import MainLogo from "../../../assets/images/taxida_white.svg";
import Toggle from "../../../assets/images/burger.svg";
import DarkLogo from "../../../assets/images/taxida_black.svg";
import "./header.scss";
import AccessControl from "../../access-control";
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.authUser = this.props.auth.getAuthUser();
  }
  state = {
    headerClass: "dropdown-content",
    sidebarOpen: false,
    menu_class: ""
  };

  toggleHeaderMenu = () => {
    this.setState({
      headerClass:
        this.state.headerClass === "dropdown-content"
          ? `${this.state.headerClass} responsive`
          : "dropdown-content"
    });
  };
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  handleClickOutside = e => {
    if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
      this.setState({
        headerClass: "dropdown-content"
      });
    }
  };
  /**
   * Method is to toggle sidebar
   */
  toggleSidebar = () => {
    this.props.dispatch({
      type: "TOGGLE_SIDEBAR",
      payload: { visible: !this.props.sidebar.visible }
    });
  };

  setToggleTopMenuClass = () => {
    if (this.state.menu_class === "") {
      this.setState({
        menu_class: "toggled"
      });
    } else {
      this.setState({
        menu_class: ""
      });
    }
  };

  render() {
    const userRole = this.authUser.roleId || 0;
    const {
      sidebar: { visible: isOpen }
    } = this.props;
    const header_menu_class = `fixed-header ${this.state.menu_class}`;
    const { firstName, lastName, email, countryCode, phone } = this.authUser;

    return (
      <div>
        <header className={header_menu_class}>
          <span
            className="main-logo main-bg"
            style={{
              display: isOpen ? "inline-flex" : "none",
              cursor: "default"
            }}
          >
            <img src={MainLogo} alt="main-logo" />
          </span>
          <span
            className="main-logo white-bg"
            style={{
              display: isOpen ? "none" : "inline-flex",
              cursor: "default"
            }}
          >
            <img src={DarkLogo} alt="main-logo" />
          </span>
          {/* &nbsp;&nbsp;&nbsp;
          <button
            type="button"
            className={
              !this.props.sidebar.visible
                ? "pe-none toggle-menu"
                : "toggle-menu"
            }
            onClick={this.toggleSidebar}
          >
            <img src={Toggle} alt="toggle-img" />
          </button> */}
          {/* <ul className="anchorList">
            <AccessControl section="bookings.create">
              <li>
                <button type="button" className="new-booking">
                  <Link to="/b2bbookings/add">New Booking</Link>
                </button>
              </li>
            </AccessControl>
          </ul> */}
          {/* <ul ref={this.setWrapperRef} className="anchorList ml-auto">
            {userRole === 10 ? (
              <li>
                <button
                  type="button"
                  className="drop-down"
                  onClick={this.toggleHeaderMenu}
                >
                  <span className="badge">
                    {firstName.slice(0, 1).toUpperCase()}
                  </span>
                </button>
                <div className={this.state.headerClass}>
                  <div className="dropdown-header">
                    <div>{`${firstName} ${lastName}`}</div>
                    <div>{email}</div>
                    <div>{`${countryCode} ${phone}`}</div>
                  </div>
                  <div className="dropdown-item">
                    <button
                      className="logging-out"
                      type="button"
                      onClick={this.props.auth.logout}
                    >
                      Logout
                    </button>
                  </div>
                </div>
              </li>
            ) : (
              <li>
                <button
                  className="logout yellow-focus"
                  type="button"
                  onClick={this.props.auth.logout}
                >
                  Logout
                </button>
              </li>
            )}
          </ul> */}
        </header>
      </div>
    );
  }
}

export default connect(state => {
  return {
    sidebar: state.sidebar
  };
})(Header);
